import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Avatar from "./Avatar";
import axios from "axios";
import "./Admin.css";

const Allocation = () => {

  const navigate = useNavigate();
  useEffect(() => {
    const username = sessionStorage.getItem("username");
    if (!username) {
      navigate("/Signin"); // redirect if not logged in
    }
  }, [navigate]);
  const userName = sessionStorage.getItem("username");
  const userType = sessionStorage.getItem("userType");              
  const userImage = "https://broken-link.com/avatar.png";
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [tutors, setTutors] = useState([]);
  const [students, setStudents] = useState([]);
  const [scheduledClasses, setScheduledClasses] = useState([]);
  const [selectedTutor, setSelectedTutor] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedGrade, setSelectedGrade] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [repeatWeekly, setRepeatWeekly] = useState(false);
  const [recurringWeeks, setRecurringWeeks] = useState(1);
  const [istClock, setIstClock] = useState("");

  const subjects = ['Maths', 'Science', 'English', 'History', 'Physics', 'Chemistry', 'Biology', 'Vedic Maths', 'Social Studies', 'Tamil', 'Computer Science'];
  const grades = ['Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'];
  const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  const fetchUsers = async () => {
    try {
      //const res = await axios.get("http://localhost:8000/api/users");
      const res = await axios.get("https://alphabeta4success.com/api/users");
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const searchUsers = async () => {
    if (searchQuery.trim() === "") {
      fetchUsers();
      return;
    }
    try {
      //const res = await axios.get(`http://localhost:8000/api/search/${searchQuery}`);
      const res = await axios.get(`https://alphabeta4success.com/api/search/${searchQuery}`);
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => { 
    const clockInterval = setInterval(() => {
      const ist = new Date().toLocaleTimeString("en-IN", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Asia/Kolkata",
      });
      setIstClock(ist);
    }, 1000);
    //fetch users
    fetchUsers(); 
      // Fetch tutors and students dynamically
    const fetchTutors = async () => {
      try {
        //const res = await axios.get("http://localhost:8000/api/tutors");
        const res = await axios.get("https://alphabeta4success.com/api/tutors");
        setTutors(res.data);
      } catch (err) {
        console.error("Error fetching tutors:", err);
      }
    };
    const fetchStudents = async () => {
      try {
        //const res = await axios.get("http://localhost:8000/api/students");
        const res = await axios.get("https://alphabeta4success.com/api/students");
        setStudents(res.data);
      } catch (err) {
        console.error("Error fetching students:", err);
      }
    };
    fetchTutors();
    fetchStudents();
    return () => {
      clearInterval(clockInterval);
    };
    }, []);

  const handleStartTimeChange = (e) => {
    const start = e.target.value;
    setStartTime(start);
    if (!endTime) {
      const [hours, minutes] = start.split(":");
      const newHour = (parseInt(hours) + 1) % 24;
      setEndTime(`${newHour.toString().padStart(2, '0')}:${minutes}`);
    }
  };

  const handleSchedule = async () => {
    const selectedTutorObj = tutors.find(t => t.UserID === selectedTutor);
    const selectedStudentObj = students.find(s => s.UserID === selectedStudent);
  
    if (!selectedTutorObj || !selectedStudentObj || !selectedSubject || !selectedGrade || !selectedDay || !startTime || !endTime) {
      alert("Please fill in all fields.");
      return;
    }
  
    const totalWeeks = repeatWeekly ? recurringWeeks : 1;
    const newClasses = [];
  
    for (let i = 0; i < totalWeeks; i++) {
      newClasses.push({
        tutorId: selectedTutorObj.UserID,
        studentId: selectedStudentObj.UserID,
        tutor: selectedTutorObj.FullName,
        student: selectedStudentObj.FullName,
        subject: selectedSubject,
        grade: selectedGrade,
        day: selectedDay,
        startTime,
        endTime,
        weekOffset: i
      });
    }
    try {
      //const res = await axios.post("http://localhost:8000/api/schedule", newClasses);
      const res = await axios.post("https://alphabeta4success.com/api/schedule", newClasses);
      if (res.data.success) {
        setScheduledClasses([...scheduledClasses, ...newClasses]);
        resetForm();
      }
    } catch (err) {
      console.error("Error saving schedule:", err);
      // Check for conflict response from backend
      if (err.response && err.response.status === 409 && err.response.data.type === "conflict") {
        const conflictMessages = err.response.data.details.join("\n");
        alert(`Schedule conflict detected:\n${conflictMessages}`);
      } else {
        alert("Failed to save schedule.");
      }
    }
  };

  const resetForm = () => {
    setSelectedTutor('');
    setSelectedStudent('');
    setSelectedSubject('');
    setSelectedGrade('');
    setSelectedDay('');
    setStartTime('');
    setEndTime('');
    setRepeatWeekly(false);
    setRecurringWeeks(1);

  };

  const handleRemove = async (id) => {
    try {
        //alert(id);
        //await axios.delete(`http://localhost:8000/api/dschedule/${id}`);
        await axios.delete(`https://alphabeta4success.com/api/dschedule/${id}`);
        setScheduledClasses(scheduledClasses.filter(cls => cls.ID !== id));
      } catch (err) {
        console.error("Error removing class:", err);
      }
    setScheduledClasses(scheduledClasses.filter(cls => cls.id !== id));
  };

  return (
    <div>
      <section id="sidebar">
        <Link to="#" className="brand">
          <img src="/Assets/images/AB4S_logo.png" alt="AB4S" className="sidebar-logo" />
        </Link>
        
        {userType === "Admin" && (
        <>  
           <ul className="side-menu top">
            <li><Link to="/AdminDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
            <li><a href="https://alphabeta4success.com/action.html" target="_blank" rel="noopener noreferrer"><i className="bx bx-video"></i><span className="text">Classroom</span></a></li>
            <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
            <li className="active"><Link to="/Allocation"><i className="bx bxs-book-content"></i><span className="text">Allocation</span></Link></li>
            <li><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
            <li><Link to="/UserManagement"><i className="bx bxs-group"></i><span className="text">User Management</span></Link></li>
            <li><Link to="/Contacts"><i className="bx bx-id-card"></i><span className="text">Contacts</span></Link></li>
            <li><Link to="/Reports"><i className="bx bx-download"></i><span className="text">Reports</span></Link></li>
            <li><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
            <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>
           </ul>
           <ul className="side-menu">
            <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
            <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
           </ul>
        </>
        )}

        {userType === "Tutor" && (
        <>  
           <ul className="side-menu top">
            <li><Link to="/TutorDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
            <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
            <li><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
            <li><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
            <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>
           </ul>
           <ul className="side-menu">
            <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
            <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
           </ul>
        </>
        )}
      </section>

      <section id="content">
        <nav>
          <i className="bx bx-menu"></i>
          <h3><span className="highlight-purple">Happy Learning <i className='bx bxs-smile'></i></span></h3>
          <form onSubmit={(e) => { e.preventDefault(); searchUsers(); }}>
            <div className="form-input">
              <input type="search" placeholder="Search by username..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
              <button type="submit" className="search-btn" onClick={searchUsers}>
                <i className="bx bx-search"></i>
              </button>
            </div>
          </form>
          <input type="checkbox" id="switch-mode" hidden />
          <label htmlFor="switch-mode" className="switch-mode"></label>
          <div className="topbar-right" style={{ display: "flex", alignItems: "center", gap: 30 }}>
            <span style={{ marginRight: "6px", fontWeight: 600 }}>
              ⏰ -  {istClock} : IST
            </span>
            <span style={{ marginLeft: 8 }}><h3>Welcome, {userName}</h3></span>
            <Avatar name={userName} src={userImage} size={30} className="avatar" />
          </div>
        </nav>
        <main>
          <div className="head-title">
            <div className="left">
              <h2>Schedule a Class</h2>
            </div>
          </div>
          <table>
            <tbody>
                <tr>
                    <td>
                    <div className="allocation-form p-4">
                      <table>
                          <tbody>
                              <tr>
                                  <td>
                                  <select className="border p-2 w-full mb-2" value={selectedStudent} onChange={e => setSelectedStudent(e.target.value)}>
                                  <option value="">-- Select Student --</option>
                                  {students.map(s => <option key={s.UserID} value={s.UserID}>{s.FullName}</option>)}
                                  </select>
                                  </td>
                                  <td>
                                  <select className="border p-2 w-full mb-2" value={selectedTutor} onChange={e => setSelectedTutor(e.target.value)}>
                                  <option value="">-- Select Tutor --</option>
                                  {tutors.map(t => <option key={t.UserID} value={t.UserID}>{t.FullName}</option>)}
                                  </select>
                                  </td>
                                  <td>
                                  <select className="border p-2 w-full mb-2" value={selectedSubject} onChange={e => setSelectedSubject(e.target.value)}>
                                  <option value="">-- Select Subject --</option>
                                  {subjects.map(sub => <option key={sub} value={sub}>{sub}</option>)}
                                  </select>
                                  </td>
                                  <td>
                                  <select className="border p-2 w-full mb-2" value={selectedGrade} onChange={e => setSelectedGrade(e.target.value)}>
                                  <option value="">-- Select Grade --</option>
                                  {grades.map(gr => <option key={gr} value={gr}>{gr}</option>)}
                                  </select>
                                  </td>
                                  <td>
                                  <select className="border p-2 w-full mb-2" value={selectedDay} onChange={e => setSelectedDay(e.target.value)}>
                                  <option value="">-- Select Day --</option>
                                  {weekdays.map(day => <option key={day} value={day}>{day}</option>)}
                                  </select>
                                  </td>
                                  <td>
                                  <div className="flex gap-2 mb-2">
                                  <input type="time" className="border p-2 w-1/2" value={startTime} onChange={handleStartTimeChange} />
                                  <input type="time" className="border p-2 w-1/2" value={endTime} onChange={e => setEndTime(e.target.value)} />
                                  </div>
                                  </td>
                                  <td>
                                  {/* <div className="mb-2">
                                  <label className="mr-2">
                                  <input type="checkbox" checked={repeatWeekly} onChange={e => setRepeatWeekly(e.target.checked)} /> Repeat Weekly
                                  </label>
                                  {repeatWeekly && (
                                  <input type="number" min="1" max="12" className="border p-1 ml-2 w-20" value={recurringWeeks} onChange={e => setRecurringWeeks(parseInt(e.target.value))} />
                                  )}
                                  </div> */}
                                  </td>
                                <td>
                                <button onClick={handleSchedule} className="bg-blue-500 text-white p-2 rounded">Schedule Class</button>  
                                </td>
                          </tr>
                      </tbody>
                    </table>
                    </div>
                    {/* <div className="allocation-form p-4">
                    <table>
                        <h3 className="highlight-red">Manage Subject,Grade & Boards list</h3>
                        <tbody>
                            <tr>
                              <td>
                                <table>
                                  <td>
                                  <input placeholder="Enter Subject" name="txtsubject" required/>
                                  </td>
                                  <td>
                                  <button className="btn-demo">Add</button>
                                  </td>
                                  <td>
                                  <input placeholder="Enter Grade" name="txtgrade" required/>
                                  </td>
                                  <td>
                                  <button className="btn-demo">Add</button>
                                  </td>
                                  <td>
                                  <input placeholder="Enter Type of Board" width={"200px"} name="txtboard" required/>
                                  </td>
                                  <td>
                                  <button className="btn-demo">Add</button>
                                  </td>
                                </table>
                              </td>
                             </tr>
                        </tbody>
                        </table>
                    </div> */}
                    <div className="allocation-form p-4">
                            <h3 className="highlight-red">Scheduled Classes</h3>
                            {scheduledClasses.length > 0 ? (
                                <table className="w-full mt-2 border-collapse border border-gray-300">
                                <thead>
                                    <tr className="bg-gray-200">
                                    <th className="border px-4 py-2">Student</th>
                                    <th className="border px-4 py-2">Tutor</th>
                                    <th className="border px-4 py-2">Day</th>
                                    <th className="border px-4 py-2">Time</th>
                                    <th className="border px-4 py-2">Subject</th>
                                    <th className="border px-4 py-2">Grade</th>
                                    <th className="border px-4 py-2">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {scheduledClasses.map(cls => (
                                    <tr key={cls.id} className="hover:bg-gray-100">
                                        <td className="border px-4 py-2">{cls.student}</td>
                                        <td className="border px-4 py-2">{cls.tutor}</td>
                                        <td className="border px-4 py-2">{cls.day}</td>
                                        <td className="border px-4 py-2">{cls.startTime} - {cls.endTime}</td>
                                        <td className="border px-4 py-2">{cls.subject}</td>
                                        <td className="border px-4 py-2">{cls.grade}</td>
                                        <td className="border px-4 py-2 flex gap-2">
                                        <button onClick={() => handleRemove(cls.id)} className="btn-demo">Remove</button>
                                        </td>
                                    </tr>
                                    ))}
                                </tbody>
                                </table>
                            ) : (
                                <p className="mt-2 text-gray-500">No classes scheduled yet.</p>
                            )}
                    </div>
                    </td>
                </tr>
            </tbody>
          </table>
        </main>
      </section>
    </div>
  );
};

export default Allocation;
